import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'kt-payment-mode-image-preview',
    templateUrl: './payment-mode-image-preview.component.html',
    styleUrls: ['./payment-mode-image-preview.component.scss']
})
export class PaymentModeImagePreviewComponent {
    constructor(
        public dialogRef: MatDialogRef<PaymentModeImagePreviewComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { desktopImage: string, mobileImage: string }
    ) { }

    onClose(): void {
        this.dialogRef.close();
    }
}
